import { useCallback, useEffect, useState } from 'react';
import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useSeek } from '@/scenarios/legacy-player/hooks/useSeek';

import { useSkipAnalytics } from './use-skip-analytics';

const useSkip = (currentFragment?: SkippableFragment) => {
    const [isCanceled, setIsCanceled] = useState(false);

    useEffect(() => {
        setIsCanceled(false);
    }, [currentFragment]);

    const { seekToTime } = useSeek();

    const skip = useCallback(
        () => currentFragment?.endTime && seekToTime(currentFragment.endTime),
        [currentFragment, seekToTime]
    );

    const cancel = useCallback(() => setIsCanceled(true), []);

    return {
        isSkipEnabled: currentFragment && !isCanceled,
        skip,
        cancel,
        fragmentEndTime: currentFragment?.endTime,
    };
};

export const useSkipWithAnalytics = (currentFragment?: SkippableFragment) => {
    const { skip, ...rest } = useSkip(currentFragment);

    const { skipWithAnalytics, onSkipButtonShow } = useSkipAnalytics(skip, currentFragment);
    return {
        ...rest,
        skip: skipWithAnalytics,
        onSkipButtonShow,
    };
};
